import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const AuthBrokerProfilesPage = React.lazy(() => import("@mediaspace/features/auth-broker-profiles"));

export const render = getStandaloneComponentRenderer(AuthBrokerProfilesPage);
